import React from 'react'
import * as S from './styles'
import { HowItWorksTexts } from '@shared/interfaces/HowItWorksTexts'
import HowItWorksList from '../HowItWorksList'
import HowItWorksHeader from '@site/components/molecules/HowItWorksHeader'
import { Page } from '@shared/interfaces/Pages'
import { StrapiHomeHowTagWorks } from '@shared/utils/strapi/strapi.types'
import { ReactComponent as FlagDesktop } from '../../../images/howItWorks/flag-desktop.svg'
import { ReactComponent as FlagMobile } from '../../../images/howItWorks/flag-mobile.svg'
import { isMobile } from 'react-device-detect'

const HowItWorks = ( { page, subscriptionPlans, homeHowItWorks }: HowItWorks.Props ): React.ReactElement => {
  const textByPage = page !== 'home' ? HowItWorksTexts[ page ]( subscriptionPlans ) : undefined
  const subtitle = textByPage?.subtitle ?? homeHowItWorks?.subtitle.split( ',' )
  return (
    <>
      {page === 'home' ? (
        <S.WrapperHeader>
          <S.HomeFlag className="how-it-works__home-flag">
            {isMobile ? <FlagMobile /> : <FlagDesktop />}
          </S.HomeFlag>
          <HowItWorksHeader
            title={ textByPage?.title ?? homeHowItWorks?.title }
            subtitle={ subtitle }
            color={ textByPage?.colorText ?? homeHowItWorks?.colorText }
            page={ page }
          />
        </S.WrapperHeader>
      ) : (
        <HowItWorksHeader
          title={ textByPage?.title ?? homeHowItWorks?.title }
          subtitle={ subtitle }
          color={ textByPage?.colorText ?? homeHowItWorks?.colorText }
          page={ page }
        />
      )}
      <S.BodyBenefits className="how-it-works__body-benefits">
        <S.Wrapper className="how-it-works__wrapper">
          <HowItWorksList
            data={ textByPage?.column ?? homeHowItWorks?.column }
            colorTitle={ textByPage?.colorTextColumn ?? homeHowItWorks?.colorTextColumn }
            page={ page }
          />
        </S.Wrapper>
      </S.BodyBenefits>
    </>
  )
}

namespace HowItWorks {
  export interface Props {
    page: Page
    subscriptionPlans?: any
    homeHowItWorks?: StrapiHomeHowTagWorks
  }
}

export default HowItWorks
